// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"888d641f","787":"5b69a3ba","942":"f2c34154"}[chunkId] + ".chunk.js";
};